<template>
  <div
    class="account-balance account-page__content"
    :class="{ _has_error: !!error }"
  >
    <div class="account-balance__title">Баланс</div>

    <AccountBalanceTabs
      class="account-balance__tabs"
      :tab="activeTab"
      :tabs="['История поступлений', 'Вывод средств']"
      @change="activeTab = $event"
    >
      <template #sidebar>
        <div class="account-balance__tabs-chips">
          <AccountBalanceChip
            class="_x-large"
            value="23643"
            money
          >
            <template #left>
              <span class="account-balance__tabs-chips-text lighter">
                Доход за<br> всё время
              </span>
            </template>
          </AccountBalanceChip>

          <AccountBalanceChip
            class="_x-large _dark-blue"
            style="margin-left: 0.75em"
            value="23643"
            money
          >
            <template #left>
              <span class="account-balance__tabs-chips-text lighter">
                Текущий<br> баланс
              </span>
            </template>
          </AccountBalanceChip>

          <AccountBalanceCashRequestButton/>
        </div>
      </template>
    </AccountBalanceTabs>

    <AccountBalanceIncoming
      v-if="activeTab === 0"
      :items="incoming"
    />

    <AccountBalanceOutcoming
      v-if="activeTab === 1"
      :items="outcoming"
    />
  </div>
</template>

<script>
  // import { http } from '@/axios';

  import AccountBalanceTabs from '@/components/balance/AccountBalanceTabs';
  import AccountBalanceChip from '@/components/balance/AccountBalanceChip';
  import AccountBalanceIncoming from '@/components/balance/AccountBalanceIncoming';
  import AccountBalanceOutcoming from '@/components/balance/AccountBalanceOutcoming';
  import AccountBalanceCashRequestButton from '@/components/balance/AccountBalanceCashRequestButton';

  export default {
    name: 'AccountBalancePage',

    components: {
      AccountBalanceTabs,
      AccountBalanceChip,
      AccountBalanceIncoming,
      AccountBalanceOutcoming,
      AccountBalanceCashRequestButton
    },

    data() {
      return {
        pending: true,
        error: null,

        activeTab: 0,
        incoming: [],
        outcoming: []
      };
    },

    methods: {
      load() {
        this.incoming = [
          {
            date: Date.now(),
            income: 'from',
            completer: 'employee',
            summa: 22467,
            action: {
              type: 'successfully-job',
              target: {
                id: 1,
                name: 'C-3PO',
                avatar: 'https://www.small-screen.co.uk/wp-content/uploads/2019/10/star-wars-the-rise-of-skywalker-c3p0-1050x450.jpg'
              }
            }
          },
          {
            date: Date.now(),
            income: 'to',
            completer: 'partner',
            summa: 660,
            partner: {
              id: 2,
              name: 'George Lucas',
              avatar: 'https://avatars.mds.yandex.net/get-kinopoisk-image/1704946/8ee84f4c-6732-4ab5-b8ed-f1fd71f209d7/360'
            },
            action: {
              type: 'bought-guarantee'
            }
          },
          {
            date: Date.now(),
            income: 'from',
            completer: 'partner',
            summa: 210,
            action: {
              type: 'bought-ticket',
              target: {
                id: 3,
                name: 'John Travolta',
                avatar: 'https://thumbs.dfs.ivi.ru/storage4/contents/5/8/3a177aa1e7ef0e7b925e01863daca6.jpg'
              }
            }
          },
          {
            date: Date.now(),
            income: 'to',
            completer: 'employee',
            summa: 210,
            partner: {
              id: 4,
              name: 'Mark Hamill'
            },
            action: {
              type: 'bought-ticket'
            }
          },
          {
            date: Date.now(),
            income: 'from',
            completer: 'employee',
            summa: 100,
            action: {
              type: 'new-employee',
              target: {
                id: 5,
                name: 'Mark Ruffalo',
                avatar: 'https://www.biography.com/.image/t_share/MTE5NDg0MDU1MzY3ODEyNjIz/hydraulic-fracturing-prevention-press-conference.jpg'
              }
            }
          },
          {
            date: Date.now(),
            income: 'from',
            completer: 'partner',
            summa: 14000,
            action: {
              type: 'successfully-job'
            }
          },
          {
            date: Date.now(),
            income: 'to',
            completer: 'employee',
            summa: 10430,
            partner: {
              id: 6,
              name: 'Carrie Fisher',
              avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Carrie_Fisher_2013.jpg/254px-Carrie_Fisher_2013.jpg'
            },
            action: {
              type: 'successfully-job',
              target: {
                id: 7,
                name: 'Harrison Ford',
                avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/PA-43286804.jpg/274px-PA-43286804.jpg'
              }
            }
          },
          {
            date: Date.now(),
            income: 'to',
            completer: 'employee',
            summa: 230,
            partner: {
              id: 8,
              name: 'Alec Guinness',
              avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Sir_Alec_Guinness_Allan_Warren_%282%29.jpg/220px-Sir_Alec_Guinness_Allan_Warren_%282%29.jpg'
            },
            action: {
              type: 'bought-ticket'
            }
          },
          {
            date: Date.now(),
            income: 'to',
            completer: 'partner',
            summa: 570,
            partner: {
              id: 9,
              name: 'Harrison Ford',
              avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/PA-43286804.jpg/274px-PA-43286804.jpg'
            },
            action: {
              type: 'bought-guarantee'
            }
          }
        ];

        this.outcoming = [
          {
            dateRequest: Date.now(),
            method: 'card',
            status: 'pending',
            summa: -22000
          },
          {
            dateRequest: Date.now(),
            method: 'cash',
            status: 'process',
            summa: -600
          },
          {
            dateRequest: Date.now(),
            datePaid: Date.now(),
            method: 'other',
            status: 'paid',
            summa: -200
          },
          {
            dateRequest: Date.now(),
            datePaid: Date.now(),
            method: 'card',
            status: 'paid',
            summa: -100
          },
          {
            dateRequest: Date.now(),
            datePaid: Date.now(),
            method: 'cash',
            status: 'paid',
            summa: -14000
          },
          {
            dateRequest: Date.now(),
            datePaid: Date.now(),
            method: 'card',
            status: 'paid',
            summa: -10000
          },
          {
            dateRequest: Date.now(),
            datePaid: Date.now(),
            method: 'card',
            status: 'paid',
            summa: -200
          }
        ];

        // this.pending = true;
        // this.error = null;

        // return http.get(`/api/new-resume/get/${this.resumeId}`).then(({ data }) => {
        //   // ...
        // }).catch((error) => {
        //   this.error = error.response && error.response.data.message || error.message;
        // }).finally(() => {
        //   this.pending = false;
        // });
      }
    },

    created() {
      this.load();
    }
  };
</script>
